// KL-26: order type
export enum InspectionType {
	Inspection = 1,
	Supervision = 2,
	Monitoring = 3,
}
